module.exports = __webpack_public_path__ + "static/cooking-tab-app-cover-4a9bc9c41a5d564822b04fd2719c4840.png";